import React from 'react'
import firebase from 'firebase/app'
import { Table, Button, Header } from 'semantic-ui-react'
import styled from 'styled-components'

import utils from '../../../utils'
import timeFormNow from '../../reports/components/TimeFromNow'

const Container = styled.div``

const HeaderWrapper = styled.div`
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Amount = styled.div`
  font-weight: bold;
  color: rgb(208, 62, 62);
`

export default ({ user, nonVerifyTransactions, gettingNonVerifyTransactions, getNonVerifyTransactions, setNonVerifyTransaction }) => {
  const approveTransaction = async transaction => {
    setNonVerifyTransaction({ ...transaction, loading: true })

    await firebase
      .firestore()
      .collection('pre_driver_credits')
      .doc(transaction.id)
      .update({ status: 'verified' })

    const { key } = firebase.database().ref('/deliverer_credits').push()
    const updates = {}

    updates[`/deliverer_credits/${transaction.deliverer}/${key}`] = {
      auto_calculate: true,
      description: `Driver deposit via ABA Payway. Verified by: ${user.username}`,
      handler: 'ABA_PAY',
      type: 'deposit',
      created_at: Date.now(),
      updated_at: Date.now(),
      value: transaction.payment_gateway.amount,
      payment_gateway: transaction.payment_gateway || null,
    }

    await firebase.database().ref().update(updates)

    setNonVerifyTransaction({ ...transaction, loading: false, status: 'verified' })
  }

  const renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={6} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  const renderRow = transaction => {
    const { id, deliverer, loading, payment_gateway: paymentGateway, delivererName, status } = transaction
    const { amount, tran_id: tranId, created_at: createdAt } = paymentGateway

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{tranId}</Table.Cell>
        <Table.Cell textAlign="center">{delivererName}</Table.Cell>
        <Table.Cell textAlign="center">{deliverer}</Table.Cell>
        <Table.Cell textAlign="center">{timeFormNow(createdAt)}</Table.Cell>
        <Table.Cell textAlign="center"><Amount>{utils.helpers.convertToCurrency(amount)}</Amount></Table.Cell>
        <Table.Cell textAlign="center">
          <Button
            size="mini"
            color="green"
            content={status === 'verified' ? 'Verified' : 'Approve'}
            loading={loading}
            disabled={loading || status === 'verified'}
            onClick={() => approveTransaction(transaction)}
          />
          <Button
            size="mini"
            content="View Driver"
            onClick={() => window.open(`/drivers/detail/${deliverer}`)}
          />
        </Table.Cell>
      </Table.Row>
    )
  }


  return (
    <Container>
      <HeaderWrapper>
        <Header style={{ marginBottom: 0 }}>List of Non-Verify Transactions</Header>
        <Button icon="refresh" onClick={getNonVerifyTransactions} loading={gettingNonVerifyTransactions} />
      </HeaderWrapper>

      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign="center">Transaction Number</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Driver Name</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Driver Tel</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Datetime</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{nonVerifyTransactions.length > 0 ? nonVerifyTransactions.map(renderRow) : renderNoDataRow()}</Table.Body>
      </Table>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/containers/drivers/components/NonVerifyTransactions.js